import {Component, Inject, OnInit} from '@angular/core';
import {
  TuiAlertService,
  TuiButtonModule,
  TuiDialogService,
  TuiDropdownModule,
  TuiLoaderModule,
  TuiSvgModule, TuiTextfieldControllerModule,
} from "@taiga-ui/core";
import {ActivatedRoute, Router} from "@angular/router";
import {MemberService} from "../../../core/services/member.service";
import {CommonModule} from "@angular/common";
import {TuiActiveZoneModule, TuiForModule, TuiObscuredModule, TuiValueChangesModule} from "@taiga-ui/cdk";
import {
  TUI_PROMPT, TuiDataListWrapperModule,
  TuiDialogFormService, TuiInputDateRangeModule,
  TuiInputModule, TuiMarkerIconModule, TuiPaginationModule,
  TuiPromptData, TuiSelectModule,
  TuiTabsModule,
  TuiTextareaModule,TuiInputPasswordModule
} from "@taiga-ui/kit";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {FormsModule} from "@angular/forms";
import {FileService} from "../../../core/services/file.service";
import {TuiTableModule} from "@taiga-ui/addon-table";
import {PageSize} from "../../../core/dto/page.size";
import {PaymentService} from "../../../core/services/payment.service";
import {AuthService} from "../../../modules/auth/services/auth.service";
import {Pagination} from "../../../core/dto/pagination";
import {SETTINGS} from "../../../core/config/common.settings";
import { Location } from '@angular/common';

const MEMBER_ATTACHMENT =
  'MEMBER_ATTACHMENT';

@Component({
  imports: [TuiButtonModule, TuiSvgModule, TuiDropdownModule, CommonModule, TuiActiveZoneModule, TuiObscuredModule, TuiLoaderModule, TuiTabsModule, TuiTextareaModule, FormsModule, TuiInputModule, TuiDataListWrapperModule, TuiInputDateRangeModule, TuiPaginationModule, TuiSelectModule, TuiTableModule, TuiTextfieldControllerModule, TuiValueChangesModule, TuiMarkerIconModule, TuiInputPasswordModule, ReactiveFormsModule, TuiForModule],
  providers: [
    MemberService,
    AuthService,
    PaymentService,
    FileService,
    TuiDialogFormService
  ],
  selector: 'app-member-single',
  standalone: true,
  styleUrl: './member-single.component.scss',
  templateUrl: './member-single.component.html'
})
export class MemberSingleComponent implements OnInit {

  memberId: any;
  memberData: any;
  memberFiles: any[] = [];
  openStates = false;
  isLoading = false;
  isLoadingAtt = false;
  tabIndex = 0;
  notes = '';
  tempNotes = ''
  goals = '';
  tempGoals = ''
  dateType = [
    'Validity Period',
    'Payment Date',
  ];
  pageSize = new PageSize();
  searchText: any;
  dateFilter: any;
  dateTypeSelect = null;
  paymentData: any[] = [];
  statusMsg = false;
  showSearch = false;
  tempSearchText:any;
  user:any;


  validFromSort = -1;
  validToSort = -1;
  paymentDateSort = -1;
  sortType = 'paymentDate';

  passwordForm!: FormGroup;
  formErrors: any;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private paymentService: PaymentService,
              private authService: AuthService,
              private memberService: MemberService,
              @Inject(TuiDialogFormService) private readonly dialogForm: TuiDialogFormService,
              @Inject(TuiDialogService) private readonly dialogs: TuiDialogService,
              @Inject(TuiAlertService) private readonly alerts: TuiAlertService,
              private fileService: FileService,
              private formBuilder: FormBuilder,
              private location: Location) {
  }

  ngOnInit(): void {
    this.initPasswordForm();
    this.route.params.subscribe((params) => {
      const tab = params['tab'];
      if(tab){
        this.tabIndex = 1
      }

    this.user = this.authService.getLoggedInUser();

    this.memberId = this.route.snapshot.paramMap.get('id');
    if (this.user.userType === SETTINGS.USERS.MEMBER) {
      this.isLoading = true;
      this.memberService.getOneMemberByMemberLogged().then(
        (res: any) => {
          this.isLoading = false;
          this.memberResponseAdded(res)
        },
        (e: any) => {
          this.isLoading = false;
        },
      );
    } else if (this.memberId) {
      this.isLoading = true;
      this.memberService.getOneMemberById(this.memberId).then(
        (res: any) => {
          this.isLoading = false;
         this.memberResponseAdded(res)
        },
        (e: any) => {
          this.isLoading = false;
        },
      );
    }
  })
  }
  memberResponseAdded(res: any) {
    this.memberData = res;
    this.notes = this.memberData.notes;
    this.goals = this.memberData.goals;
    this.memberFiles = this.memberData.attachments;
    this.tempNotes = this.notes;
    this.tempGoals = this.goals;
    this.getPaginatedPayment()
  }
  // @ViewChild('paymentDialog') paymentDialogTemplate!: TemplateRef<any>;
  // protected showPaymentDialog(): void {
  //   this.dialogs
  //       .open(
  //           this.paymentDialogTemplate,
  //           { size: 'm'},
  //       ).subscribe();
  // }


  protected paymentPageNavigate(): void {
    const url = `member/card-pay/${this.memberId || this.user.userId}`;
    window.location.href = url;
  }
    getPaginatedPayment(): void {
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      filters: {
        memberId: this.memberId,
        searchValue: this.searchText,
        dateFilter: this.dateFilter,
        dateType: this.dateTypeSelect,

        sortType: this.sortType,
        validFromSort: this.validFromSort,
        validToSort: this.validToSort,
        paymentDateSort: this.paymentDateSort,
      },
    });
    this.isLoading = true;
    if (this.user.userType === SETTINGS.USERS.ADMIN) {
      this.paymentService.getPagedPayment(payload).then((res) => {
        this.paymentData = res.data;
        this.isLoading = false;
        this.pageSize.length = res.totalPages;

      }).catch((error) => {
        this.isLoading = false;
      })
    } else {
      this.paymentService.getPagedPaymentByMemberLogged(payload).then((res) => {
        this.paymentData = res.data;
        this.isLoading = false;
        this.pageSize.length = res.totalPages;

      }).catch((error) => {
        this.isLoading = false;
      })
    }

  }

  displayArrayWithCommas(array: string[]): string {
    if (array.length === 0) {
      return '';
    } else if (array.length === 1) {
      return array[0];
    } else {
      return array.slice(0, -1).join(', ') + ', ' + array[array.length - 1];
    }
  }



  isPaymentPaid(data: any): boolean {
    return true;
  }

  showPaymentMethod(data: any): string {
    // Backend stores paidBy as ['Online'|'Cash'] per SETTINGS
    const value = Array.isArray(data?.paidBy) && data.paidBy.length ? data.paidBy[0] : null;
    if (!value) return '-';
    const up = String(value).toUpperCase();
    if (up.includes('ONLINE')) return 'Online';
    if (up.includes('CASH')) return 'Cash';
    return String(value);
  }

  openDeleteConfirmation(index: any,filename: any): void {
    const data: TuiPromptData = {
      content:
        `Are you sure you want to delete the file "${filename}"`,
      yes: 'Yes',
      no: 'No',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        label: 'File Delete',
        size: 's',
        data,
      })
      .subscribe(response=>{
       if (response) {
         this.memberFiles.splice(index, 1);
         this.memberService.updateMember(
           {_id: this.memberId, attachments: this.memberFiles}
         ).then(()=>{
           this.alerts
             .open('<p style="color: green">File Deleted Successfully</p>')
             .subscribe();
         })
       }
      });
  }

  toggle(): void {
    this.showSearch = !this.showSearch;
  }

  toggleSortValidFromDate() : void {

    if (this.validFromSort === -1) {
      this.validFromSort = 1;
    } else {
      this.validFromSort = -1
    }
    this.sortType = 'validFrom';
    this.getPaginatedPayment();
  }

  toggleSortValidToDate() : void {

    if (this.validToSort === -1) {
      this.validToSort = 1;
    } else {
      this.validToSort = -1
    }
    this.sortType = 'validTo'
    this.getPaginatedPayment();
  }

  toggleSortPaymentDate() : void {

    if (this.paymentDateSort === -1) {
      this.paymentDateSort = 1;
    } else {
      this.paymentDateSort = -1
    }
    this.sortType = 'paymentDate'
    this.getPaginatedPayment();
  }



  resetStatus(): void {
    this.searchText = null;
    this.dateFilter = null;
    this.statusMsg = false;
    this.dateTypeSelect = null;
    this.tempSearchText = null;

    this.getPaginatedPayment()
  }

  showText(): string {
    let text = '';
    if (this.statusMsg && this.tempSearchText) {
    text += `Showing Results for "${this.tempSearchText}"`;
    }
    return text;
  }
  search(): void {
    this.statusMsg = true;
    this.tempSearchText = this.searchText
    this.getPaginatedPayment()
  }

  cancelSearch(event: Event): void {
    if (!event) {
      this.searchText = null;
      this.getPaginatedPayment();
    }
  }

  goToPage(event: any): void {
    this.pageSize.pageIndex = event + 1;
    this.getPaginatedPayment();
  }

  navigateToPaymentUpdate(data: any): void {
    if (this.user.role !== 'USER') {
      this.router.navigate([`admin/payment/add-edit/${data._id}`, {status: 'single'}]);
    }
  }

  triggerFileInput() {
    document.getElementById('fileInput')?.click(); // Trigger click event on file input
  }

  onFileSelected(event: any) {
    this.isLoadingAtt = true;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
        const file: File = files[0];
        this.fileService.postFile(file,MEMBER_ATTACHMENT).subscribe((res)=>{
          this.memberFiles.push({ name: file.name, url: res.url });
          this.isLoadingAtt = false;
          this.memberService.updateMember(
            {_id: this.memberId, attachments: this.memberFiles}
          ).then(()=>{
            this.alerts
              .open('<p style="color: green">File Uploaded Successfully</p>')
              .subscribe();
          })
        })

      }

  }
  viewPaymentAdd(): void {
    this.router.navigate([`admin/payment/add-edit`, {status: 'single',user: this.memberData._id},])
  }

  saveNote(): void {
    this.notes = this.tempNotes;

    this.memberData.notes = this.notes;

    this.isLoading = true;
    this.memberService.updateMember(this.memberData).then(() => {
      this.isLoading = false;
      this.alerts
        .open('<p style="color: green">Member Note Saved</p>',)
        .subscribe();
    }).catch(() => {
      this.isLoading = false;
      this.alerts
        .open('<p style="color: red">Error Updating Note</p>',{status: 'error'})
        .subscribe();
    })

  }

  saveGoals(): void {
    this.goals = this.tempGoals;

    this.memberData.goals = this.goals;

    this.isLoading = true;
    this.memberService.updateMember(this.memberData).then(() => {
      this.isLoading = false;
      this.alerts
        .open('<p style="color: green">Member Goals Saved</p>',)
        .subscribe();
    }).catch(() => {
      this.isLoading = false;
      this.alerts
        .open('<p style="color: red">Error Updating Goals</p>',{status: 'error'})
        .subscribe();
    })

  }

  onClickCancelGoals(content: any): void {
    const closeable = this.dialogForm.withPrompt({
      label: 'Are you sure?',
      data: {
        content: 'Your data will be <strong>lost</strong>',
      },
    });

    this.dialogs.open(content, {closeable, dismissible: closeable}).subscribe({
      complete: () => {
        this.tempGoals = this.goals;
        this.dialogForm.markAsPristine();
      },
    });
  }

  onClickCancel(content: any): void {
    const closeable = this.dialogForm.withPrompt({
      label: 'Are you sure?',
      data: {
        content: 'Your data will be <strong>lost</strong>',
      },
    });

    this.dialogs.open(content, {closeable, dismissible: closeable}).subscribe({
      complete: () => {
        this.tempNotes = this.notes;
        this.dialogForm.markAsPristine();
      },
    });
  }

  navigateToView(): void {
    if (this.user.userType === SETTINGS.USERS.ADMIN) {
      this.router.navigate(['admin/members'])
    }
  }

  formatDate(dateString: any) {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  }

  formatDateText(inputDate: string): string {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.toLocaleString('default', {month: 'short'});
    const year = date.getFullYear();
    const suffix = this.getDaySuffix(day);

    return `${day}${suffix} ${month} ${year}`;
  }

  private getDaySuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  onClick(): void {
    this.openStates = !this.openStates;
  }

  onActiveZone(): void {
    // Handle active zone change event
  }

  onObscured(event: any): void {
  }

  navigateToUpdate(): void {
    if (this.user.userType === SETTINGS.USERS.ADMIN) {
      this.router.navigate([`admin/members/add-edit/${this.memberData._id}`, {status: 'single'}])
    } else {
      this.router.navigate([`member/members/add-edit`, {status: 'single'}])
    }
  }


  onStatusChange(user: any): void {

    let content = '';
    let yesLabel = '';
    let noLabel = '';

    if (user.isActive) {
      content = `Are you sure you want to deactivate Member : ${user.email}`;
      yesLabel = 'Deactivate';
      noLabel = 'Cancel';
    } else {
      content = `Are you sure you want to activate Member : ${user.email}`;
      yesLabel = 'Activate';
      noLabel = 'Cancel';
    }

    const data: TuiPromptData = {
      content: content,
      yes: yesLabel,
      no: noLabel,
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response) {
          user.isActive = !user.isActive
          this.isLoading = true;
          this.memberService.updateMember(
            {
              _id: user._id,
              ...user
            }
          ).then(() => {
            this.isLoading = false;
            this.openStates = false;
            this.alerts
              .open('<p style="color: green">Member Status Changed Successfully</p>')
              .subscribe();
            this.ngOnInit();
          }).catch(() => {
            this.isLoading = false;
            this.alerts
              .open('<p style="color: red">Member Status Change UnSuccessful</p>',{status: 'error'})
              .subscribe();
          })
        }
      });
  }

  tabChange(id: any): void {
    this.tabIndex = id;
  }

  onDelete(): void {
    const data: TuiPromptData = {
      content:
        `Are you sure you want to delete ${this.memberData.email}`,
      yes: 'Yes',
      no: 'Cancel',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response) {
          this.isLoading = true;
          this.memberService.softDeleteMember(this.memberId).then(() => {
            this.isLoading = false;
            this.openStates = false;
            this.alerts
              .open('<p style="color: green">Member Deleted Successfully</p>')
              .subscribe();
            this.navigateToView();
          }).catch(() => {
            this.isLoading = false;
            this.alerts
              .open('<p style="color: red">Deleting Member Unsuccessful</p>',{status: 'error'})
              .subscribe();
          });
        }
      });
  }

  initPasswordForm(): void {
    this.passwordForm = this.formBuilder.group({
      oldPassword: [null, Validators.compose([Validators.required])],
      newPassword: [null, Validators.compose([Validators.required, Validators.minLength(4)])],
      confirmPassword: [null, Validators.compose([Validators.required])]
    }, { validator: this.passwordMatchValidator });
    this.passwordForm.valueChanges.subscribe(() => {
      this.formErrors = this.getFormErrors(this.passwordForm, this.formErrors);
    });
  }

  passwordMatchValidator(group: FormGroup): { [key: string]: any } | null {
    const newPasswordControl = group.get('newPassword');
    const confirmPasswordControl = group.get('confirmPassword');
    if (!newPasswordControl || !confirmPasswordControl) {
      return null;
    }
    if (newPasswordControl.value !== confirmPasswordControl.value) {
      return { passwordMismatch: true };
    } else {
      return null;
    }
  }

  getFormErrors(form: FormGroup, errors: any): any {
    // Implement your logic to get form errors here
    return errors;
  }

  onChangePassword(): void {
    const data: TuiPromptData = {
      content:
        `Are you sure you want to change password?`,
      yes: 'Yes',
      no: 'Cancel',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response && this.passwordForm.valid) {
           const formData = {
             oldPassword: this.passwordForm.get('oldPassword')?.value,
             newPassword: this.passwordForm.get('newPassword')?.value,
           }
            this.isLoading = true;
            this.memberService.changePasswordMemberByLoggedMember({
              ...formData
            }).then(() => {
              this.isLoading = false;
              this.passwordForm.reset()
              this.alerts.open('<p style="color: green">Member Password Changed Successful</p>').subscribe();
            }).catch((e) => {
              this.isLoading = false;
                this.alerts.open(`<p style="color: red">${e.oldPwdCheck ? e.message : "Member Password Change Unsuccessful"}</p>`, { status: 'error' }).subscribe();
            });

        }
      });
  }
  cancel(): void {
    const data: TuiPromptData = {
      content:
        `Are you sure you want to reset inputs`,
      yes: 'Yes',
      no: 'Cancel',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response) {
          this.passwordForm.reset()
        }
      });
  }

  goBack(): void {
    this.location.back();
  }

  protected readonly SETTINGS = SETTINGS;
}
